import { combineReducers } from 'redux';
import DonationsReducer from './donations/reducer';
import DonorsReducer from './donors/reducer';
import EnvelopesReducer from './envelopes/reducer';
import LifeTimeReducer from './lifeTime/reducer';

export default combineReducers({
    LifeTime: LifeTimeReducer,
    Donations: DonationsReducer,
    Donors: DonorsReducer,
    Envelopes: EnvelopesReducer,
});
